
import { TableOfContentsItem } from "@/components/blog/TableOfContents";

export const negocioIaTableOfContents: TableOfContentsItem[] = [
  {
    id: "oportunidades",
    title: "Oportunidades de la inteligencia artificial",
    subItems: [
      {
        id: "impacto",
        title: "Impacto en el éxito empresarial"
      },
      {
        id: "nuevas-oportunidades",
        title: "Nuevas oportunidades de negocio"
      },
      {
        id: "casos-exito",
        title: "Casos de éxito"
      }
    ]
  },
  {
    id: "integracion",
    title: "Integración de IA en tu negocio",
    subItems: [
      {
        id: "objetivos",
        title: "Definición de objetivos claros"
      },
      {
        id: "herramientas",
        title: "Selección de herramientas adecuadas"
      },
      {
        id: "capacitacion",
        title: "Capacitación del equipo"
      }
    ]
  },
  {
    id: "areas-clave",
    title: "Áreas clave para aplicar IA",
    subItems: [
      {
        id: "ventas-marketing",
        title: "Ventas y marketing"
      },
      {
        id: "atencion-cliente",
        title: "Atención al cliente"
      },
      {
        id: "recursos-humanos",
        title: "Gestión de recursos humanos"
      },
      {
        id: "procesos-internos",
        title: "Optimización de procesos internos"
      }
    ]
  },
  {
    id: "ventajas",
    title: "Ventajas de la IA en la empresa",
    subItems: [
      {
        id: "eficiencia",
        title: "Eficiencia operativa y reducción de costes"
      },
      {
        id: "experiencia-cliente",
        title: "Mejora de la experiencia del cliente"
      },
      {
        id: "decisiones-datos",
        title: "Toma de decisiones basada en datos"
      }
    ]
  },
  {
    id: "desafios",
    title: "Desafíos y consideraciones",
    subItems: [
      {
        id: "ciberseguridad",
        title: "Ciberseguridad y protección de datos"
      },
      {
        id: "cultura-innovacion",
        title: "Cultura de innovación"
      },
      {
        id: "gestion-cambios",
        title: "Gestión de cambios organizacionales"
      }
    ]
  },
  {
    id: "estrategias",
    title: "Estrategias para maximizar el uso de IA",
    subItems: [
      {
        id: "monitoreo",
        title: "Monitoreo y evaluación de resultados"
      },
      {
        id: "cultura",
        title: "Fomento de una cultura de innovación"
      },
      {
        id: "colaboracion",
        title: "Colaboración interdepartamental"
      }
    ]
  }
];
